import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslocoModule],
	// TranslocoModule é exportado aqui para que o pipe `| transloco` fique
	// disponível em todos os módulos que já importam o SharedModule, sem
	// precisar declarar o import em cada um deles.
	exports: [CommonModule, FormsModule, ReactiveFormsModule, TranslocoModule],
})
export class SharedModule {}
